
import { Component, Vue } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import PageLoader from '@/components/common/PageLoader.vue';
import PasswordInput from '@/components/common/Inputs/Password.vue';
import TextInput from '~/components/Inputs/Text.vue';
import { isValidPassword } from '@/utils/validators';
import { createAccountPassword, getInformationFromToken } from '@/api/account';
import { getError, getNonFieldError } from '@/utils/error-handler';

@Component({
  components: {
    Alert,
    CustomButton,
    PageLoader,
    PasswordInput,
    TextInput,
  }
})
export default class CreateAccount extends Vue {
  userName = '';

  userEmail = '';

  password = '';

  confirmPassword = '';

  loadingPage = true;

  loadingSubmit = false;

  errorMessage = '';

  $refs!: {
    pwdForm: HTMLFormElement
  };

  get validForm() {
    return isValidPassword(this.password) && this.password === this.confirmPassword;
  }

  async submit() {
    this.loadingSubmit = true;
    try {
      await createAccountPassword({
        password: this.password,
        token: this.$route.query.token as string
      });
      this.$router.push({ name: 'bank-account-setup' });
    } catch (e) {
      const error = e as AxiosError;

      if (error.response?.status === 400) {
        this.errorMessage = getError(e).password[0];
      } else {
        this.errorMessage = getNonFieldError(e) || 'We are unable to set your password, please try again.';
      }
    } finally {
      this.loadingSubmit = false;
      this.password = '';
      this.confirmPassword = '';
      this.$refs.pwdForm.resetValidation();
    }
  }

  async created() {
    const token = this.$route.query.token as string;

    try {
      const { data } = await getInformationFromToken(token as string);
      this.userName = data.first_name;
      this.userEmail = data.email;
      this.loadingPage = false;
    } catch (e) {
      const error = e as AxiosError;
      switch (error.response?.status) {
        case 400:
          this.$alerts.add({
            type: GlobalAlertTypes.WARNING,
            timed: true,
            text: 'An account has already been created. Please login using your credentials.'
          });
          this.$router.push({ name: 'login' });
          break;

        default:
          this.$router.push({ name: 'invalid' });
          break;
      }
    }
  }
}
